var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-video is-progress-bar",class:{'in-progress': _vm.pageProgress}},[_c(_vm.activeView,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }